export default "__VITE_ASSET__17sK4tWZ__"